import { gql } from '@apollo/client';
import { CART_DATA_DEFAULT_RESULT_PROPS } from './constants';

const CREATE_CART_MUTATION = gql`
  mutation ecommerceCartCreate(
    $currency: String!, $lineItems: [EcommerceCartCreateInputLineItemsItem]!
    ) {
    cartData: ecommerceCartCreate(input: { currency: $currency, lineItems: $lineItems }) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const UPDATE_CART_MUTATION = gql`
  mutation ecommerceCartUpdate($input: EcommerceCartUpdateInput) {
    cartData: ecommerceCartUpdate(input: $input) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const ADD_DISCOUNT_TO_CART_MUTATION = gql`
  mutation ecommerceCartAddDiscount($id: String!, $code: String!){
  cartData: ecommerceCartAddDiscount(input: {
    id: $id,
    code: $code
  }){
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const REMOVE_DISCOUNT_FROM_CART_MUTATION = gql`
  mutation ecommerceCartRemoveDiscount($id: String!, $discountId: String!){
  cartData: ecommerceCartRemoveDiscount(input: {
    id: $id,
    discountId: $discountId
  }){
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const ADD_ITEMS_TO_CART_MUTATION = gql`
  mutation ecommerceCartAddLineItems(
    $id: String!,
    $currency: String!,
    $lineItems: [EcommerceCartAddLineItemsInputLineItemsItem]!
  ) {
    cartData: ecommerceCartAddLineItems(input: { id: $id, lineItems: $lineItems, currency: $currency }) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const UPDATE_CART_ITEMS_MUTATION = gql`
  mutation ecommerceCartUpdateLineItems(
    $id: String!
    $lineItems: [EcommerceCartUpdateLineItemsInputLineItemsItem]!
    $currency: String!
  ) {
    cartData: ecommerceCartUpdateLineItems(input: { id: $id, lineItems: $lineItems, currency: $currency }) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const DELETE_ITEMS_FROM_CART = gql`
  mutation ecommerceCartDeleteLineItems(
    $id: String!
    $lineItems: [EcommerceCartDeleteLineItemsInputLineItemsItem]!
  ) {
    cartData: ecommerceCartDeleteLineItems(input: { id: $id, lineItems: $lineItems }) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const CREATE_RECREATE_MUTATION = gql`
  mutation ecommerceCartRecreate(
    $id: String!,
    $currency: String,
  ) {
    cartData: ecommerceCartRecreate(input: { id: $id, currency: $currency }) {
      result {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const CART_CHECKOUT_MUTATION = gql`
  mutation ecommerceCartCheckout($input: EcommerceCartCheckoutInput!) {
    ecommerceCartCheckout(input: $input) {
      result {
        id
        reference
        paymentUrl
        paymentInstructions
      }
    }
  }
`;

const CREATE_USER_ADDRESS = gql`
  mutation createUserAddress($input: CreateUserAddressInput!) {
    createUserAddress(input: $input) {
      result {
        id
      }
    }
  }
`;

const UPDATE_USER_ADDRESS = gql`
  mutation updateUserAddress($input: UpdateUserAddressInput!) {
    updateUserAddress(input: $input) {
      result {
        id
      }
    }
  }
`;

const DELETE_USER_ADDRESS = gql`
  mutation deleteUserAddress($input: DeleteUserAddressInput!) {
    deleteUserAddress(input: $input) {
      result {
        id
      }
    }
  }
`;

export {
  CREATE_RECREATE_MUTATION,
  CART_CHECKOUT_MUTATION,
  CREATE_CART_MUTATION,
  ADD_DISCOUNT_TO_CART_MUTATION,
  REMOVE_DISCOUNT_FROM_CART_MUTATION,
  ADD_ITEMS_TO_CART_MUTATION,
  UPDATE_CART_MUTATION,
  UPDATE_CART_ITEMS_MUTATION,
  DELETE_ITEMS_FROM_CART,
  CREATE_USER_ADDRESS,
  DELETE_USER_ADDRESS,
  UPDATE_USER_ADDRESS
};
